/* ==========================================================================
   SCMERS — comportements du thème
   Menu, compte à rebours, braises, accordéons, tailles, archive, carte.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------- GRAIN ---- */
  if (!document.querySelector('.grain')) {
    var g = document.createElement('div');
    g.className = 'grain';
    g.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">' +
      '<filter id="gr"><feTurbulence type="fractalNoise" baseFrequency=".9" numOctaves="3" stitchTiles="stitch"/></filter>' +
      '<rect width="100%" height="100%" filter="url(#gr)"/></svg>';
    document.body.appendChild(g);
  }

  /* ------------------------------------------------------------ MENU ---- */
  var menu = document.querySelector('[data-menu]');
  if (menu) {
    var setMenu = function (v) {
      menu.dataset.open = v;
      document.body.style.overflow = v === 'true' ? 'hidden' : '';
    };
    var openBtn = document.querySelector('[data-menu-open]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (openBtn) openBtn.addEventListener('click', function () { setMenu('true'); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu('false'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu('false'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMenu('false');
    });
  }

  /* -------------------------------------------------- COMPTE À REBOURS -- */
  document.querySelectorAll('[data-clock]').forEach(function (el) {
    var target = new Date(el.dataset.target).getTime();
    if (isNaN(target)) return;

    var slots = el.querySelectorAll('[data-u]');
    var daysEl = document.querySelector('[data-days]');
    var pad = function (n) { return String(Math.max(0, n)).padStart(2, '0'); };

    var tick = function () {
      var gap = target - Date.now();
      if (gap <= 0) {
        slots.forEach(function (s) { s.textContent = '00'; });
        el.classList.add('clock--done');
        if (daysEl) daysEl.textContent = "aujourd'hui";
        return;
      }
      var v = {
        d: Math.floor(gap / 864e5),
        h: Math.floor(gap / 36e5) % 24,
        m: Math.floor(gap / 6e4) % 60,
        s: Math.floor(gap / 1e3) % 60
      };
      slots.forEach(function (n) { n.textContent = pad(v[n.dataset.u]); });
      if (daysEl) daysEl.textContent = v.d + ' jour' + (v.d > 1 ? 's' : '');
    };
    tick();
    setInterval(tick, 1000);
  });

  /* -------------------------------------------------------- ACCORDÉONS -- */
  document.querySelectorAll('.acc__btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var item = b.closest('.acc__item');
      var open = item.dataset.open === 'true';
      item.dataset.open = String(!open);
      b.querySelector('span:last-child').textContent = open ? '+' : '–';
    });
  });

  /* ------------------------------------------------------------ TAILLES - */
  var sizes = document.querySelector('[data-sizes]');
  if (sizes) {
    var input = document.querySelector('[data-variant-input]');
    var add = document.querySelector('[data-add]');
    var msg = document.querySelector('[data-msg]');
    var chosen = null;

    sizes.querySelectorAll('.size').forEach(function (b) {
      if (b.disabled) return;
      b.addEventListener('click', function () {
        sizes.querySelectorAll('.size').forEach(function (o) {
          o.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-pressed', 'true');
        chosen = b.dataset.variant;
        if (input) input.value = chosen;
        if (msg) msg.textContent = '';
      });
    });

    var form = sizes.closest('form');
    if (form && add) {
      form.addEventListener('submit', function (e) {
        if (!chosen) {
          e.preventDefault();
          if (msg) msg.textContent = 'Choisir une taille';
        }
      });
    }
  }

  /* -------------------------------------------------------- ARCHIVE ----- */
  var chapters = document.querySelectorAll('.ch');
  chapters.forEach(function (ch) {
    var btn = ch.querySelector('.ch__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = ch.dataset.open === 'true';
      chapters.forEach(function (o) {
        o.dataset.open = 'false';
        o.querySelector('.ch__btn').setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        ch.dataset.open = 'true';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ------------------------------------------------- CARTE DES VENTES --- */
  document.querySelectorAll('[data-map]').forEach(function (box) {
    if (typeof salesMap !== 'function') return;

    var points = (box.dataset.cities || '')
      .split('\n')
      .map(function (l) { return l.trim(); })
      .filter(Boolean)
      .map(function (l) {
        var p = l.split(',');
        return { city: p[0], lon: parseFloat(p[1]), lat: parseFloat(p[2]), n: parseInt(p[3], 10) || 1 };
      })
      .filter(function (p) { return !isNaN(p.lon) && !isNaN(p.lat); });

    box.insertAdjacentHTML('afterbegin', salesMap(points));
    var count = box.querySelector('[data-map-count]');
    if (count) count.textContent = points.length + ' villes';
  });

  /* ================================================================
     FOND ANIMÉ — braises et remontées de chaleur
     ================================================================ */
  document.querySelectorAll('[data-hero]').forEach(function (host) {
    mountParticles(host, { flames: host.dataset.flames === 'true' });
  });

  function mountParticles(el, opts) {
    opts = opts || {};
    var canvas = document.createElement('canvas');
    canvas.className = 'particles';
    canvas.setAttribute('aria-hidden', 'true');
    el.prepend(canvas);

    var ctx = canvas.getContext('2d', { alpha: true });
    var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var COLORS = ['#FF4A00', '#FF7A1A', '#FFD24A', '#FFF0C2'];

    var w = 0, h = 0, dpr = 1, parts = [], flames = [], raf = null, t = 0;
    var mouse = { x: -9999, y: -9999, on: false };
    var halo = { x: 0, y: 0, a: 0, set: false };
    var R = 130, R2 = R * R;
    var HALO = 250, HALO2 = HALO * HALO;

    function size() {
      var r = el.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function spawn(y) {
      return {
        x: Math.random() * w,
        y: y !== undefined ? y : h + 10,
        r: 0.5 + Math.random() * 1.9,
        vy: -(0.06 + Math.random() * 0.22),
        vx: (Math.random() - 0.5) * 0.08,
        amp: 0.25 + Math.random() * 0.9,
        freq: 0.004 + Math.random() * 0.012,
        phase: Math.random() * Math.PI * 2,
        px: 0, py: 0,
        a: 0.15 + Math.random() * 0.55,
        c: COLORS[(Math.random() * COLORS.length) | 0],
        tw: Math.random() * Math.PI * 2
      };
    }

    function newFlame(seeded) {
      return {
        x: Math.random() * w,
        y: h + 90,
        life: seeded ? Math.random() * 0.7 : 0,
        span: 240 + Math.random() * 260,
        rise: 0.22 + Math.random() * 0.45,
        wob: 0.5 + Math.random() * 1.3,
        freq: 0.012 + Math.random() * 0.02,
        size: 54 + Math.random() * 90,
        hue: Math.random() < 0.35 ? '#FFD24A' : '#FF4A00'
      };
    }

    function drawFlame(f) {
      if (f.life <= 0 || f.life >= 1) return;
      var fade = f.life < 0.18 ? f.life / 0.18 : (1 - f.life) / 0.82;
      var a = Math.max(0, fade) * 0.4;
      var x = f.x + Math.sin(t * f.freq * 4 + f.x) * f.wob * 9;
      var s = f.size * (0.55 + fade * 0.45);

      var g = ctx.createRadialGradient(x, f.y, 0, x, f.y, s);
      g.addColorStop(0, f.hue === '#FFD24A' ? 'rgba(255,210,74,.55)' : 'rgba(255,74,0,.6)');
      g.addColorStop(0.4, 'rgba(255,74,0,.26)');
      g.addColorStop(1, 'rgba(255,74,0,0)');

      ctx.globalAlpha = a;
      ctx.globalCompositeOperation = 'lighter';
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.ellipse(x, f.y, s * 0.5, s * 1.25, 0, 0, 6.283);
      ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
    }

    /* Lueur douce qui suit le curseur, en retard sur lui. */
    function drawHalo() {
      var s = HALO + Math.sin(t * 0.011) * 22;
      var g = ctx.createRadialGradient(halo.x, halo.y, 0, halo.x, halo.y, s);
      g.addColorStop(0, 'rgba(255,138,40,.22)');
      g.addColorStop(0.32, 'rgba(255,74,0,.09)');
      g.addColorStop(1, 'rgba(255,74,0,0)');
      ctx.globalCompositeOperation = 'lighter';
      ctx.globalAlpha = halo.a;
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(halo.x, halo.y, s, 0, 6.283);
      ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
    }

    function seed() {
      var n = Math.min(440, Math.round(w * h / 3400));
      parts = [];
      for (var i = 0; i < n; i++) parts.push(spawn(Math.random() * h));

      var fc = opts.flames ? Math.max(3, Math.round(w / 300)) : 0;
      flames = [];
      for (var j = 0; j < fc; j++) flames.push(newFlame(true));
    }

    function frame() {
      t += 1;
      ctx.clearRect(0, 0, w, h);

      if (mouse.on) {
        if (!halo.set) { halo.x = mouse.x; halo.y = mouse.y; halo.set = true; }
        halo.x += (mouse.x - halo.x) * 0.075;
        halo.y += (mouse.y - halo.y) * 0.075;
        halo.a += (1 - halo.a) * 0.045;
      } else {
        halo.a += (0 - halo.a) * 0.035;
        if (halo.a < 0.004) halo.set = false;
      }
      if (halo.a > 0.004) drawHalo();

      for (var i = 0; i < flames.length; i++) {
        var f = flames[i];
        f.life += 1 / f.span;
        f.y -= f.rise;
        drawFlame(f);
        if (f.life >= 1 || f.y < h * 0.42) flames[i] = newFlame(false);
      }

      for (var k = 0; k < parts.length; k++) {
        var p = parts[k];
        p.x += p.vx + Math.sin((t + p.phase * 120) * p.freq) * p.amp * 0.22;
        p.y += p.vy;

        if (mouse.on) {
          var dx = p.x + p.px - mouse.x;
          var dy = p.y + p.py - mouse.y;
          var d2 = dx * dx + dy * dy;
          if (d2 < R2 && d2 > 0.01) {
            var d = Math.sqrt(d2);
            var push = (1 - d / R) * 26;
            p.px += (dx / d) * push * 0.08;
            p.py += (dy / d) * push * 0.08;
          }
        }
        p.px *= 0.93;
        p.py *= 0.93;

        if (p.y < -12 || p.x < -40 || p.x > w + 40) { parts[k] = spawn(); continue; }

        var lift = 1;
        if (halo.a > 0.01) {
          var hx = p.x + p.px - halo.x, hy = p.y + p.py - halo.y;
          var hd2 = hx * hx + hy * hy;
          if (hd2 < HALO2) lift = 1 + (1 - hd2 / HALO2) * 0.9 * halo.a;
        }
        ctx.globalAlpha = Math.min(1, Math.max(0, p.a * (0.6 + 0.4 * Math.sin(t * 0.03 + p.tw)) * lift));
        ctx.fillStyle = p.c;
        ctx.beginPath();
        ctx.arc(p.x + p.px, p.y + p.py, p.r, 0, 6.283);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }

    function start() { if (!raf && !slow) raf = requestAnimationFrame(frame); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    function still() {
      ctx.clearRect(0, 0, w, h);
      parts.forEach(function (p) {
        ctx.globalAlpha = p.a * 0.8;
        ctx.fillStyle = p.c;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
      });
      ctx.globalAlpha = 1;
    }

    size(); seed();
    if (slow) still(); else start();

    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      mouse.x = e.clientX - r.left;
      mouse.y = e.clientY - r.top;
      mouse.on = true;
    }, { passive: true });
    el.addEventListener('pointerleave', function () { mouse.on = false; });

    var tm;
    window.addEventListener('resize', function () {
      clearTimeout(tm);
      tm = setTimeout(function () { size(); seed(); if (slow) still(); }, 180);
    });
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  }
})();

/* ================================================================
   ETERNEL — filtre de catégorie
   ================================================================ */
(function () {
  var bar = document.querySelector('[data-filter]');
  var grid = document.querySelector('[data-cat-grid]');
  if (!bar || !grid) return;

  var cells = [].slice.call(grid.querySelectorAll('.cell'));
  var tabs = [].slice.call(bar.querySelectorAll('[data-cat]'));

  function apply(cat) {
    cells.forEach(function (c) {
      c.hidden = !(cat === 'all' || c.dataset.type === cat);
    });
    tabs.forEach(function (t) {
      t.setAttribute('aria-selected', t.dataset.cat === cat ? 'true' : 'false');
    });
    if (history.replaceState) {
      history.replaceState(null, '', cat === 'all' ? location.pathname : location.pathname + '#' + cat);
    }
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () { apply(t.dataset.cat); });
  });

  var hash = (location.hash || '').replace('#', '').replace(/"/g, '');
  if (hash && bar.querySelector('[data-cat="' + hash + '"]')) apply(hash);
})();
